import angular from 'angular'
import accountSubject from './accountSubject'

export default angular
    .module('declaration.baseSetting', [accountSubject])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('declaration.baseSetting', {
            abstract: true,
            url: '/baseSetting',
            template: '<div ui-view></div>',
            title: '基础设置',
        })
    }])
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/baseSetting/index.js